import { Caption } from '@liveauctioneers/hammer-ui-core/text';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import {
    getItemSummaryBidCount,
    getItemSummaryIsPassed,
    getItemSummaryIsPaused,
    getItemSummaryIsSold,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import { useAppSelector } from '@/redux/hooks';
import ItemCardMenu from '@/components/ItemCard/components/Menu/ItemCardMenu';
import ItemCardPriceRow from '@/components/GridItemCard/Card/components/ItemCardPriceRow/ItemCardPriceRow';
import styled from 'styled-components';

export type CardPriceProps = {
    cardHovered: boolean;
    enterLinkHoverState: () => void;
    isMobile: boolean;
    isPending: boolean;
    itemId: number;
    leaveLinkHoverState: () => void;
    linkHovered: boolean;
};

const CardPrice = ({
    cardHovered,
    enterLinkHoverState,
    isMobile,
    isPending,
    itemId,
    leaveLinkHoverState,
    linkHovered,
}: CardPriceProps) => {
    const bidCount = useAppSelector((state) => getItemSummaryBidCount(state, itemId));
    const isSold = useAppSelector((state) => getItemSummaryIsSold(state, itemId));
    const isPassed = useAppSelector((state) => getItemSummaryIsPassed(state, itemId));
    const isPaused = useAppSelector((state) => getItemSummaryIsPaused(state, itemId));
    const isLoggedIn = useAppSelector(isUserLoggedIn);

    return (
        <PriceInformation data-testid="myItemsCardPrice">
            <StyledBidInfo>
                <ItemCardPriceRow
                    isHovered={linkHovered}
                    itemId={itemId}
                    onMouseEnter={enterLinkHoverState}
                    onMouseLeave={leaveLinkHoverState}
                />
                {!isSold && !isPassed && !isPaused && !isPending && bidCount > 0 && (
                    <StyledBidCount color="secondary">
                        <FormattedMessage
                            id="itemBidding.bid"
                            values={{ bidCount }}
                        />
                    </StyledBidCount>
                )}
            </StyledBidInfo>
            {isLoggedIn && !isMobile && (
                <ItemCardMenu
                    itemId={itemId}
                    showIcon={cardHovered}
                />
            )}
        </PriceInformation>
    );
};

export default CardPrice;

const StyledBidInfo = styled.section`
    display: flex;
    align-items: center;
`;

const PriceInformation = styled.section`
    grid-area: currentbidprice;
    display: flex;
    justify-content: space-between;
`;

const StyledBidCount = styled(Caption)`
    margin-left: 4px;
`;
